import {IIncome} from "../config/income";
import {IIncomeState} from "../components/Settings/Incomes/Form/IncomeForm";

export const toFormData = (input: IIncome): IIncomeState => {
    return {
        name: input.name,
        amount: input.amount.toString(),
    };
};
